import { MDBTable } from "mdbreact";
import { Services } from "../../../services/fakeDb";
import { currency } from "../../../services/utilities";

const Row = ({ menu, mark = false }) => {
  const { description, abbreviation, packages = [], up, discount = 0 } = menu;

  return (
    <tr>
      <td
        style={{ fontSize: "17.5px" }}
        className="text-left py-0 px-0 text-uppercase"
      >
        {description || abbreviation}
        {mark && " **"}
        {Array.isArray(packages) &&
          packages.length > 1 &&
          packages.map((id, pIndex) => {
            const service = Services?.find?.(id);
            if (!service) return null;

            const { name, abbreviation } = service;
            return (
              <div key={`package-${pIndex}`} className="ml-4 stub-item">
                -{abbreviation || name}
              </div>
            );
          })}
      </td>
      <td style={{ fontSize: "17.5px" }} className="text-right py-0 px-0">
        {currency.format(up + discount)}
      </td>
    </tr>
  );
};

const Section = ({ title }) => (
  <tr>
    <th colSpan={2} className="text-left py-0 px-0 pt-1" style={{ fontSize: "17.5px" }}>
      {title}
    </th>
  </tr>
);

// dashed line between the promo and the discountable services
const Divider = ({ colSpan }) => (
  <tr>
    <td colSpan={colSpan} className="p-0">
      <hr
        style={{ border: "none", borderTop: "1px dashed #000", height: 0 }}
        className="my-1"
      />
    </td>
  </tr>
);

// markFixed: PWD / Senior / Indigenous sale, the items without discount
// are listed apart (promo) from the discountable ones
const Body = ({ cart, markFixed = false }) => {
  const items = Array.isArray(cart) ? cart : [];
  const fixed = markFixed ? items.filter(({ discount = 0 }) => !(discount > 0)) : [];
  const discountable = markFixed ? items.filter(({ discount = 0 }) => discount > 0) : items;

  return (
    <MDBTable responsive borderless className="mb-0 thermal-font">
      <thead>
        <tr>
          <th colSpan={2} className="py-0" style={{ fontSize: "17.5px" }}>
            Services
          </th>
        </tr>
      </thead>
      <tbody>
        {markFixed && <Section title="PROMO SERVICES" />}
        {fixed.map((menu, index) => (
          <Row key={`fixed-${index}`} menu={menu} mark />
        ))}
        {markFixed && <Divider colSpan={2} />}
        {markFixed && <Section title="DISCOUNTABLE SERVICES" />}
        {discountable.map((menu, index) => (
          <Row key={`menu-${index}`} menu={menu} />
        ))}
      </tbody>
    </MDBTable>
  );
};

export default Body;
